// @flow

import type {MarkdocAstNode, MarkdocConfig} from 'markdoc/types';
import type {CodeGeneratorSnippetArgs} from '../../../../../server/services';

export const REPLACEMENT_KEY = '$$TEST_KEY_REPLACE_ME$$';
export const LANGUAGES = [
  'curl',
  // TODO (matv): cli is not fully supported and tested in codegen yet.
  'cli',
  'ruby',
  'python',
  'php',
  'java',
  'node',
  'go',
  'dotnet',
];

export const codegenNodeToCodegenArgs = (
  node: MarkdocAstNode,
  config: MarkdocConfig,
): CodeGeneratorSnippetArgs => {
  const attributes: {
    path: string,
    method: string,
    args: any,
  } = (node.attributes: any);

  // This resolves args like $merchant.currency to be
  // the value in the config
  const resolvedArgs: any = node.resolve(attributes.args, config);

  const requestArgs: CodeGeneratorSnippetArgs = {
    test_key: REPLACEMENT_KEY,
    path: attributes.path,
    verb: attributes.method.toLowerCase(),
    args: resolvedArgs,
  };

  return requestArgs;
};
